import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import * as styles from "/src/components/About/AboutValues.module.css";

const AboutValues = (props) => {
  return (
    <div className={styles.aboutValuesContainer}>
      <div className={styles.aboutValue1}>
        <h3>Recycling made simple.</h3>
        <p>{props.recyclingMadeSimpleText}</p>
        <hr />
      </div>

      <div className={styles.aboutValue2}>
        <StaticImage
          placeholder="tracedSVG"
          alt="Cat Drawing"
          src="../../images/about-kittydraw.png"
          layout="fixed"
          width={200}
          className={styles.image}
        />
        <section>
          <h3>Refining circular economies.</h3>
          <p>{props.refiningCircularEconomiesText}</p>
        </section>
      </div>

      <div className={styles.aboutValue2}>
        <section style={{ alignItems: "flex-end", marginRight: 20 }}>
          <h3>Redefining the future.</h3>
          <p style={{ textAlign: "right" }}>{props.redefiningTheFutureText}</p>
        </section>
        <StaticImage
          placeholder="tracedSVG"
          alt="Astronaut"
          src="../../images/about-astro.png"
          layout="fixed"
          width={200}
          className={styles.image}
        />
      </div>
    </div>
  );
};

export default AboutValues;
